export type Size = "xs" | "sm" | "md" | "lg" | "xl";
export type ButtonVariant = "primary" | "primary-destructive" | "secondary" | "tertiary" | "underlined";
export type AlertType = "error" | "notify" | "success" | "warning";
export type FeedbackId = "feedback-error" | "feedback-warning" | "feedback-server-error";
export type MenuStatus = "accept" | "active" | "empty" | "error" | "idle" | "unsaved" | "warning";

export enum KeyboardKey {
  Enter,
  Shift,
  Down,
  Up,
}
